// Core
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Spinner from './Spinner';

// Styling
import { Loader } from '../../style/layout/elements/Loading.style';

const Loading = ({
  testId,
  className,
  color,
  size,
}) => {
  const classNames = className || '';

  return (
    <Loader data-testid={testId} className={classNames}>
      <Spinner size={size} color={color} />
    </Loader>
  );
};

Loading.propTypes = {
  testId: PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
};

Loading.defaultProps = {
  testId: undefined,
  className: undefined,
  color: undefined,
  size: 'lg',
};

export default Loading;
